import React from "react";
import Footer from "../components/Footer";
import SubHeader from "../components/SubHeader";

function Pekoe() {
  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg" />
          {/* /.page-header__bg */}
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li>
                <a href="index.html">Home</a>
              </li>
              <li>
                <span>Activities</span>
              </li>
              <li>
                <span>The Pekoe Trail</span>
              </li>
            </ul>
            {/* /.thm-breadcrumb list-unstyled */}
            <h2 className="page-header__title">The Pekoe Trail</h2>
          </div>
          {/* /.container */}
        </section>
        {/* /.page-header */}
        <section className="destinations-details">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="destinations-details__image">
                  <img
                    src="assets/images/activities/pekoe/main.webp?v=20260924"
                    alt="villoz"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="destinations-details__content">
                  {/* <h3 className="destinations-details__title">
                    The Pekoe Trail
                  </h3>
                  <h5>
                    Stage 1: Hanthana to Galaha
                    <br />
                    <br />
                  </h5> */}
                  <div className="col-lg-12">
                    <p style={{textAlign:"center"}}>
                      Partnered with
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        height: "10rem",
                      }}
                    >
                      <img
                        src="assets/images/activities/pekoe/pekoe.jpeg?v=20260924"
                        alt="villoz"
                      />
                    </div>
                  </div>
                  <p className="destinations-details__text">
                    This stage of the Pekoe Trail can be arranged with Pathi or
                    one of our naturalist guides, who will ensure your
                    experience is both enriching and enjoyable.
                    <br />
                    <br />
                    As you walk the trail, you’ll explore breathtaking
                    landscapes of tea gardens, forests, and meet the lovely
                    community of Hanthana, inviting you to fully immerse
                    yourself in nature’s wonders, with vibrant birds, and
                    occasional wildlife (such as peacocks, civet cats) making an
                    appearance.
                    <br />
                    <br />
                    The trail meanders through tea estates where you’ll meet
                    friendly tea pluckers at work offering a glimpse into the
                    lives of those who contribute to Sri Lanka’s renowned tea
                    industry. Your hike will then conclude in Galaha, a place
                    rich in history. It’s the perfect spot to pause and reflect.
                    <br />
                    <br />
                    If you’re interested in the Pekoe Trail, feel free to reach
                    out to{" "}
                    <a href="https://www.thepekoetrailsrilanka.com">
                      https://www.thepekoetrailsrilanka.com/
                    </a>{" "}
                    for more detailed information.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="gallery-three">
          <div className="container">
            <div
              className="gallery-three__carousel villoz-owl__carousel  villoz-owl__carousel--basic-nav owl-carousel owl-theme"
              data-owl-options='{
			"items": 5,
			"margin": 30,
			"loop": false,
			"smartSpeed": 700,
			"nav": false,
			"navText": ["<span class=\"fa fa-angle-left\"></span>","<span class=\"fa fa-angle-right\"></span>"],
			"dots": false,
			"autoplay": true,
			"responsive": {
				"0": {
					"items": 1
				},
				"360": {
					"items": 2,
					"margin": 20
				},
				"575": {
					"items": 3
				},
				"992": {
					"items": 4
				},
				"1200": {
              "margin": 42,
					"items": 5
				}
			}
			}'
            >
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/pekoe/1.webp?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/pekoe/1.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/pekoe/2.webp?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/pekoe/2.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/pekoe/3.webp?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/pekoe/3.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/pekoe/4.webp?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/pekoe/4.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/pekoe/5.webp?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/pekoe/5.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
            </div>
            {/* /.gallery-three__carousel */}
          </div>
          {/* /.container */}
        </section>
        {/* /.gallery-three */}
      </main>
      <Footer />
    </>
  );
}

export default Pekoe;
